import { IFloorplanViewModel } from '@monofe/ui-workspace/floorplan/interface';

function data(): IFloorplanViewModel {
    return {
        backgroundColor: 'transparent',
        title: {
            text: '',
            fontFamily: 'Gill Sans',
            fontSize: '10vmin',
            fontAlignment: 'center',
            fontWeight: 500,
            color: 'transparent',
            visible: false,
        },

        zoomControlsBackgroundColor: 'transparent',
        zoomControlsTintColor: 'transparent',

        items: [],

        backButton: {
            backgroundColor: 'transparent',
            strokeColor: 'transparent',
            strokeSize: 0,
            arrowColor: 'transparent',
        },

        onBack: () => {
            /* noop */
        },
    };
}

export default data;
